
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch?: () => void; // Added onSearch as an optional prop
}

const SearchBar: React.FC<SearchBarProps> = ({ searchQuery, onSearchChange, onSearch }) => {
  return (
    <Card className="mb-6">
      <CardContent className="p-2 flex">
        <div className="relative flex-1">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <Input
            type="text"
            placeholder="Buscar por nombre o legajo..."
            className="pl-10 py-2 w-full"
            value={searchQuery}
            onChange={onSearchChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && onSearch) {
                e.preventDefault();
                onSearch();
              }
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default SearchBar;
